module.exports = __webpack_public_path__ + "static/media/watermark_left_menu_top.c0602234.png";